import { Component, OnInit } from '@angular/core';
import { IsApplicationService } from '../../../core/services/is-application.service';
import { PricingService } from '../../../core/services/pricing.service';
import { HttpOfferService } from '../../../core/services/http/http-offer.service';
import { Offer } from '../../models/entities/offer.entity';
import * as AuthSelectors from '../../../core/state/auth-state/auth.selectors';
import { Store } from '@ngrx/store';
import { SubscriptionTier } from '../../models/enums/subscription.enums';
import { LanguageService } from '../../../core/services/language.service';
import { AppTypeService } from '../../../core/services/app-type.service';

@Component({
  selector: 'app-pricing-premium',
  templateUrl: './pricing-premium.component.html',
  styleUrls: ['./pricing-premium.component.scss'],
})
export class PricingPremiumComponent implements OnInit {
  currentSubscriptionTier$ = this.store.select(AuthSelectors.currentSubscriptionTier);

  offers: Offer[];

  Math = Math;
  SubscriptionTier = SubscriptionTier;

  constructor(
    private store: Store,
    public appTypeService: AppTypeService,
    public isApplicationService: IsApplicationService,
    public languageService: LanguageService,
    public pricingService: PricingService,
    private httpOfferService: HttpOfferService
  ) {}

  ngOnInit(): void {
    this.httpOfferService.list().subscribe((res) => {
      this.offers = res['hydra:member'].map((elt) => new Offer(elt));
    });
  }
}
